import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasDispatchSchema = withDefaults({
  type: 'tas-dispatch',
  objectExtensions: ['tas-dispatch'],
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'dispatchDate',
    },
    {
      kind: 'attribute',
      name: 'authorizedAt',
    },
    {
      kind: 'attribute',
      name: 'disbursedAt',
    },
    {
      kind: 'attribute',
      name: 'authorizerIds',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'authorizationCount',
    },
    {
      kind: 'attribute',
      name: 'canAuthorize',
    },
    {
      kind: 'attribute',
      name: 'canDisburse',
    },
    {
      kind: 'attribute',
      name: 'canCancel',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: true,
        inverse: null,
      },
    },
  ],
});

export default TasDispatchSchema;
